// extracted by mini-css-extract-plugin
export default {"content":"MessageContent_content__mUm4C"};